export const actions = {
  FECHA_COLOR_LOAD_REQUESTED: 'FECHA_COLOR_LOAD_REQUESTED',
  FECHA_COLOR_LOAD_SUCCEEDED: 'FECHA_COLOR_LOAD_SUCCEEDED',
  FECHA_COLOR_LOAD_FILED: 'FECHA_COLOR_LOAD_FILED',

  FECHA_COLOR_INSERT_REQUESTED: 'FECHA_COLOR_INSERT_REQUESTED',
  FECHA_COLOR_INSERT_SUCCEEDED: 'FECHA_COLOR_INSERT_SUCCEEDED',
  FECHA_COLOR_INSERT_FILED: 'FECHA_COLOR_INSERT_FILED',

  FECHA_COLOR_UPDATE_REQUESTED: 'FECHA_COLOR_UPDATE_REQUESTED',
  FECHA_COLOR_UPDATE_SUCCEEDED: 'FECHA_COLOR_UPDATE_SUCCEEDED',
  FECHA_COLOR_UPDATE_FILED: 'FECHA_COLOR_UPDATE_FILED',

  FECHA_COLOR_DELETE_REQUESTED: 'FECHA_COLOR_DELETE_REQUESTED',
  FECHA_COLOR_DELETE_SUCCEEDED: 'FECHA_COLOR_DELETE_SUCCEEDED',
  FECHA_COLOR_DELETE_FILED: 'FECHA_COLOR_DELETE_FILED',
}

export const getFechasColorAction = dispatch => {
  dispatch({
    type: actions.FECHA_COLOR_LOAD_REQUESTED,
  })
}

export const onSubmitFechaColorAction = (dispatch, fechaColorForm) => {
  dispatch({
    type: actions.FECHA_COLOR_INSERT_REQUESTED,
    payload: fechaColorForm,
  })
}

export const onSubmitFechaColorUpdateAction = (dispatch, fechaColorForm) => {
  dispatch({
    type: actions.FECHA_COLOR_UPDATE_REQUESTED,
    payload: fechaColorForm,
  })
}

export const deleteFechaColorAction = (dispatch, id) => {
  dispatch({
    type: actions.FECHA_COLOR_DELETE_REQUESTED,
    payload: id,
  })
}
